// choose your destiny! (mk)
// box2D v6
// Cave Chaos, Flipside
var _a;
import B2D_LEGACY from './Box2Dold';
// box2D unknown  =)
// Cave Chaos 2
import B2D from './Box2D';
var sayHello = true;
var B2D_MAPPING = (_a = {},
    _a["new" /* NEW */] = B2D,
    _a["legacy" /* LEGACY */] = B2D_LEGACY,
    _a["none" /* NONE */] = null,
    _a);
export var BOX2D_PREFERENCE = {
    /**
   * Prefered version of Box2D
   */
    version: "none" /* NONE */,
    custom: undefined,
    /**
   * Return prefered runtime of Box2D or empty object, if nothing was prefered
   */
    get prefer() {
        if (sayHello) {
            console.debug('B2D Version - ', this.version);
            sayHello = false;
        }
        if (this.version === "custom" /* CUSTOM */) {
            if (!this.custom)
                throw new Error('Custom Box2D should be assigned to `custom` field');
            return this.custom;
        }
        if (B2D_MAPPING[this.version]) {
            return B2D_MAPPING[this.version];
        }
        // return mapping to NONE
        return B2D_MAPPING["none" /* NONE */];
    },
};
